<template>
<!--    <div class="form-group datatime-picker-component" :id="'datetime-form-group' + _uid">-->
<!--        <label :for="'datetime' + _uid" v-if="label" v-text="label"></label>-->
<!--        <input :id="'datetime' + _uid" type="text" class="form-control" v-model="datetime" :placeholder="placeholder">-->
<!--        &lt;!&ndash;       <button v-if="hasValue" @click="clear()"><i class="material-icons">clear</i></button>&ndash;&gt;-->
<!--    </div>-->
  <div class="custom-control custom-checkbox">
    <input class="custom-control-input"
           type="checkbox"
           v-model="isChecked"
           :id="getFieldId"
           :name="name"
           @input="updateValue">
    <label class="custom-control-label" :for="getFieldId" v-text="placeholder"></label>
  </div>
</template>
<script>

    let InputField = require('@/mixins/InputField');

    export default {

        mixins: [InputField],

        data() {
            return {
                isChecked: this.value
            }
        },

        methods: {
            updateValue() {
                this.$emit('input', !this.isChecked)
                this.$emit('change', !this.isChecked)
            }
        },

        watch: {
            value(val) {
                this.isChecked = val;
            }
        }
    }
</script>